// extracted by mini-css-extract-plugin
export default {"productCarousel":"bZ-z"};